import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/companies/:creatorId']['POST'];

type Input = ThisApi['body'] & { creatorId: string };
type Output = ThisApi['response'];

const createCompany = async ({ companyName, creatorId, email, phoneNumber, pointOfContact }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/companies/${creatorId}`, { companyName, email, phoneNumber, pointOfContact });

  return response.data;
};

export default createCompany;
